import { render, staticRenderFns } from "./RuleComponent.vue?vue&type=template&id=5d692317&scoped=true&"
import script from "./RuleComponent.vue?vue&type=script&lang=js&"
export * from "./RuleComponent.vue?vue&type=script&lang=js&"
import style0 from "./RuleComponent.vue?vue&type=style&index=0&id=5d692317&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d692317",
  null
  
)

export default component.exports